import {
	CONFIRM_PASSWORD_FORM_FIELDS,
	CONFIRM_PASSWORD_FORM_FIELDS_NAMES,
	IConfirmInputs
} from './confirm-account-form';

export const CONFIRM_PASSWORD_INPUTS = ({
	t,
	showPassword, setShowPassword,
	showConfirmPassword, setShowConfirmPassword,
	showTemporaryPassword, setShowTemporaryPassword
}): IConfirmInputs[] => [
	{
		key: CONFIRM_PASSWORD_FORM_FIELDS.TEMPORARY_PASSWORD,
		fieldName: CONFIRM_PASSWORD_FORM_FIELDS.TEMPORARY_PASSWORD,
		placeholder: t(CONFIRM_PASSWORD_FORM_FIELDS_NAMES.TEMPORARY_PASSWORD),
		label: t(CONFIRM_PASSWORD_FORM_FIELDS_NAMES.TEMPORARY_PASSWORD),
		showPassword: showTemporaryPassword,
		setShowPassword: setShowTemporaryPassword,
		additionalClass: 'password-container position-relative',
		isPasswordShown: true,
		autoComplete: 'one-time-code'
	},
	{
		key: CONFIRM_PASSWORD_FORM_FIELDS.NEW_PASSWORD,
		fieldName: CONFIRM_PASSWORD_FORM_FIELDS.NEW_PASSWORD,
		placeholder: t(CONFIRM_PASSWORD_FORM_FIELDS_NAMES.NEW_PASSWORD),
		label: t(CONFIRM_PASSWORD_FORM_FIELDS_NAMES.NEW_PASSWORD),
		showPassword: showPassword,
		setShowPassword: setShowPassword,
		additionalClass: 'password-container position-relative',
		isPasswordShown: true,
		isPasswordStrengthShown: true,
		autoComplete: 'new-password'
	},
	{
		key: CONFIRM_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD,
		fieldName: CONFIRM_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD,
		placeholder: t(CONFIRM_PASSWORD_FORM_FIELDS_NAMES.CONFIRM_PASSWORD),
		label: t(CONFIRM_PASSWORD_FORM_FIELDS_NAMES.CONFIRM_PASSWORD),
		showPassword: showConfirmPassword,
		setShowPassword: setShowConfirmPassword,
		additionalClass: 'password-container',
		isPasswordShown: true,
		autoComplete: 'new-password'
	}
];
